import { render, staticRenderFns } from "./CreatedGroupPages.vue?vue&type=template&id=8bf1f5ac&lang=true"
import script from "./CreatedGroupPages.vue?vue&type=script&lang=js"
export * from "./CreatedGroupPages.vue?vue&type=script&lang=js"
import style0 from "./CreatedGroupPages.vue?vue&type=style&index=0&id=8bf1f5ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports